'use strict';

/* eslint-disable max-lines-per-function, max-params, max-len, complexity */

angular.module('webAgro1App').controller('ResumoProdutividadeCtrl', function($scope, $rootScope, $templateCache, $timeout, $q,
  OperacoesService, LoadingService, ChartsService, ContagensService, MessagesService, TarefaObjectService, OperacoesDadosService,
  InformacoesCultivaresService, AtividadesService, UNITS) {
  const template = $templateCache.get('views/infowindow_templates/infowindowoperations.tpl.html');

  $scope.filters = {};
  $scope.estadiosMarkers = [];

  $scope.removeMarkers = function() {
    $scope.$emit('clearMarkers');
  };

  const setGroupMarkers = function(markers) {
    $scope.atividadesMarker = {};
    $scope.cultivaresMarker = markers.reduce(function(result, record) {
      if (record.objeto.isWheat) {
        record.objeto.medias = ContagensService.getWheatAverages(record.objeto.samples, record.objeto.area);
      }
      result[record.objeto.cultivarForGroup.id] = result[record.objeto.cultivarForGroup.id] || [];
      result[record.objeto.cultivarForGroup.id].push(record);

      const key = record.objeto.atividade || record.objeto.estadio.atividade;
      $scope.atividadesMarker[key] = $scope.atividadesMarker[key] || [];
      $scope.atividadesMarker[key].push(record);

      return result;
    }, {});
  };

  const getTipoTarefa = function() {
    return TarefaObjectService.getTarefaTipo('produtividade');
  };

  $scope.setAtividadeMarkers = function(markers, event) {
    if (event) {
      event.preventDefault();
    }

    $scope.isCulture = true;
    $scope.removeMarkers();
    $scope.details = null;
    $scope.estadiosMarkers = getEstadiosMarkers(markers);
    $scope.setEstadioMarkers($scope.estadiosMarkers[0]);
  };

  function getEstadiosMarkers(markers) {
    let result = markers.reduce(function(group, record) {
      group[record.objeto.estadio.id] = group[record.objeto.estadio.id] || [];
      group[record.objeto.estadio.id].push(record);

      return group;
    }, {});

    result = _.map(result, function(arrValue) {
      const actives = arrValue.filter((item) => item.objeto.registroAtivo);

      return {
        quantidade: actives.length,
        media: _.reduce(actives, function(group, value) {
          return group + Number(value.objeto.fertility);
        }, 0) / actives.length,
        maxima: _.maxBy(actives, function(value) {
          return value.objeto.fertility;
        }).objeto.fertility,
        minima: _.minBy(actives, function(value) {
          return value.objeto.fertility;
        }).objeto.fertility,
        markers: arrValue,
        estadio_ordem: arrValue[0].objeto.estadio.ordem,
        estadio: {
          abreviatura: arrValue[0].objeto.estadio.abreviatura,
          descricao: arrValue[0].objeto.estadio.descricao
        }
      };
    });

    return _.sortBy(result, 'estadio_ordem').reverse();
  }

  $scope.setCultivarMarkers = function(cultivarMarkers, event) {
    if (event) {
      event.preventDefault();
    }
    $scope.isCulture = false;
    const firstMarker = (cultivarMarkers[0] || {}).objeto || {};
    setCultivar(firstMarker);
  };

  function setCultivar(marker) {
    LoadingService.showLoading();
    $scope.removeMarkers();
    $scope.details = null;
    $scope.filters.cultivar = {
      id: (marker.cultivarForGroup || {}).id || marker // EM alguns casos o marker já é um ID de cultivar
    };
    $scope.filters.safra = (marker.params || {}).safra_id;

    OperacoesService.getOperationSummary($scope.filters).then(function(result) {
      $scope.estadiosMarkers = result;
      $scope.setEstadioMarkers($scope.estadiosMarkers[0]);
    })
      .finally(LoadingService.hideLoading);
  }

  $scope.setEstadioMarkers = function(estadioMarkers, event) {
    if (event) {
      event.preventDefault();
    }

    $scope.removeMarkers();
    estadioMarkers.gleba = $scope.data.activity ? $scope.data.activity.gleba : {
      id: ($scope.data.summary.productivity || $scope.data.summary.gerais.produtividade[0]).gleba_id
    };

    $scope.details = estadioMarkers;

    if (!$scope.isCulture) {
      estadioMarkers.markers = OperacoesDadosService.newGetMarkersOperationsDayGleba(estadioMarkers.pontos, null, template);
      estadioMarkers.pms = getPMS(estadioMarkers.markers);
      estadioMarkers.pesoCapulho = getCapulhos(estadioMarkers.markers);
      estadioMarkers.correcao = getCorrectionFactor(estadioMarkers.markers);
      ChartsService.loaderStandProductivity(estadioMarkers.markers, '#chartProductivity', '#containerChartProductivity');
      $scope.isAlgodao = $scope.details.isAlgodao = AtividadesService.isAlgodao($scope.details.atividade.descricao);
      $scope.isCana = $scope.details.isCana = AtividadesService.isCana($scope.details.atividade.descricao);
      $scope.activityUnit = `${AtividadesService.getProdutividadeUnidade($scope.details.atividade.descricao)}/ha`;
      $scope.details.rawWeight = getRawWeight($scope.details.markers[0]);
      $scope.details.estimatedFinalWeight = getEstimatedFinalWeight($scope.details.markers[0], $scope.details.rawWeight);
    }

    $scope.$emit('setMarkers', estadioMarkers.markers);
  };

  function getRawWeight(marker) {
    return (marker.objeto.area * marker.objeto.gross_weight) / UNITS.hectare;
  }

  function getEstimatedFinalWeight(marker, rawWeight) {
    return Math.abs((rawWeight * UNITS.toPercent(marker.objeto.correcao)) - rawWeight);
  }

  $scope.setAllMarkers = function(event) {
    if (event) {
      event.preventDefault();
    }

    $scope.removeMarkers();
    const estadioMarkers = {
      gleba: ($scope.data.activity || {}).gleba || $scope.data.summary
    };

    if (!$scope.isCulture) {
      estadioMarkers.markers = OperacoesDadosService.newGetMarkersOperationsDayGleba($scope.estadiosMarkers.reduce(function(pontos, estadio) {
        return pontos.concat(estadio.pontos);
      }, []), null, template);
      estadioMarkers.pms = getPMS(estadioMarkers.markers);
      estadioMarkers.pesoCapulho = getCapulhos(estadioMarkers.markers);
      estadioMarkers.correcao = getCorrectionFactor(estadioMarkers.markers);
      estadioMarkers.media = $scope.estadiosMarkers.reduce(function(total, estadio) {
        return total + Number(estadio.media);
      }, 0) / $scope.estadiosMarkers.length;
      estadioMarkers.variacao = $scope.estadiosMarkers.reduce(function(total, estadio) {
        return total + Number(estadio.variacao);
      }, 0) / $scope.estadiosMarkers.length;
      ChartsService.loaderStandProductivity(estadioMarkers.markers, '#chartProductivity', '#containerChartProductivity');
    } else {
      estadioMarkers.markers = _.flatten($scope.estadiosMarkers.map((item) => item.markers));
    }
    assignMutualValues(estadioMarkers);
    $scope.$emit('setMarkers', estadioMarkers.markers);
  };

  $scope.estadioFilterLabel = function() {
    if ($scope.details && $scope.details.estadio) {
      return `${$scope.details.estadio.abreviatura } - ${ $scope.details.estadio.descricao}`;
    }
    return 'Todos';
  };

  function assignMutualValues(estadioMarkers) {
    const actives = estadioMarkers.markers.filter((item) => item.objeto.registroAtivo);
    estadioMarkers.maxima = _.maxBy(actives, (value) => value.objeto.fertility).objeto.fertility;
    estadioMarkers.minima = _.minBy(actives, (value) => value.objeto.fertility).objeto.fertility;
    estadioMarkers.quantidade = actives.length;
    $scope.details = estadioMarkers;
  }

  function getPMS(contagens) {
    return checkObjectPMSCapulhoValue(contagens);
  }

  function getCapulhos(contagens) {
    return checkObjectPMSCapulhoValue(contagens, 'pesoCapulho');
  }

  function checkObjectPMSCapulhoValue(contagens, tipo = 'pms') {
    for (let i = 1; i < contagens.length; i++) {
      if (contagens[i].objeto[tipo] !== contagens[i-1].objeto[tipo]) {
        return null;
      }
    }
    return contagens[0].objeto[tipo];
  }

  function getCorrectionFactor(contagens) {
    for (let i = 1; i < contagens.length; i++) {
      if (contagens[i].objeto.correcao !== contagens[i-1].objeto.correcao) {
        return null;
      }
    }

    return contagens[0].objeto.correcao || 0;
  }

  function InitializeProdutividade(event, markers) {
    LoadingService.showLoading();
    $rootScope.initialize.then(function() {
      markers = markers.filter((marker) => marker.objeto.produtividade);
      $scope.details = null;
      $scope.isCulture = false;
      $rootScope.tipoTarefa = getTipoTarefa();
      $scope.tipo = 'produtividade';
      $scope.cultivaresMarker = {};

      setGroupMarkers(markers);

      const cultivar = ($scope.filters.cultivar || {}).id;

      $scope.filters = {
        dia: $scope.data.activity.data,
        gleba: $scope.data.activity.gleba,
        cultivar: $scope.cultivaresMarker[cultivar] ? cultivar : null,
        operacao: {
          tipo: $scope.tipo
        }
      };

      const keyCultivarMarkers = $scope.filters.cultivar || Object.keys($scope.cultivaresMarker)[0];
      $scope.setCultivarMarkers($scope.cultivaresMarker[keyCultivarMarkers]);
      LoadingService.hideLoading();
    }, $rootScope.errorRootInitialize);
  }

  function InitializeSummary() {
    const activity = $scope.data.activity || $scope.data.summary;
    const hasProdutividadeActive = activity.gerais.produtividade.some((prod) => prod.active);
    if (hasProdutividadeActive) {
      $scope.details = activity.alerta || null;
      $scope.isCulture = false;
      $scope.activity = activity.history || activity;
      $rootScope.tipoTarefa = getTipoTarefa();
      $scope.tipo = 'produtividadeSummary';
      $scope.filters = {
        dataFinal: $scope.activity.data || null,
        operacao: { tipo: 'produtividade' },
        gleba: $scope.activity.gleba || { id: ($scope.activity.productivity || $scope.activity.gerais.produtividade[0]).gleba_id }
      };

      setCultivar($scope.data.productivity.cultivar_id || $scope.data.productivity.objeto);
    }
  }

  $scope.$watch('data', function() {
    if ($scope.data) {
      if ($scope.data.notification && $scope.data.data) {
        return InitializeProdutividade($scope.data.activity, $scope.data.data.produtividade[0].objeto.allLeafletMarkers);
      }
      InitializeSummary();
    }
  });

  $scope.$on('$destroy', function() {
    $scope.listeners();
    $scope.listeners = null;
  });

  $scope.setAnimationMarker = function(index) {
    $scope.indexMarker = index;
    $scope.$emit('startAnimatingMarker', index);
  };

  $scope.resetAnimationMarker = function(index) {
    $scope.$emit('stopAnimatingMarker', index);
    $scope.indexMarker = null;
  };

  $scope.openMarkerInfoWindow = function(index) {
    $scope.$emit('openMarkerPopup', index);
  };

  $scope.changeTargetProductivity = function() {
    LoadingService.showLoading();

    ContagensService.changeTargetProductivity($scope.details).then(function() {
      reload();
    }, function(erroForUser) {
      if (erroForUser) {
        MessagesService.alert(erroForUser);
      }
      LoadingService.hideLoading();
    });
  };

  $scope.changePesos = function() {
    ContagensService.changePesos($scope.details).then(function() {
      reload();
    }, function(erroForUser) {
      if (erroForUser) {
        MessagesService.alert(erroForUser);
      }
    });
  };

  $scope.changeCorrectionFactor = function() {
    ContagensService.changeCorrectionFactor($scope.details).then(function() {
      reload();
    }, function(erroForUser) {
      if (erroForUser) {
        MessagesService.alert(erroForUser);
      }
    });
  };

  function reload() {
    location.reload();
  }


  // TODO: Mover para componente (diretiva)
  $scope.print = function() {
    $scope.report = {
      date: new Date()
    };
    const params = {
      tp_insumo: 1,
      tipo: 1,
      safra: $scope.details.markers[0].objeto.params.safra_id,
      gleba: $scope.details.markers[0].objeto.params.gleba_id,
      insumo: $scope.details.markers[0].objeto.params.cd_insumo,
      cd_insumo: $scope.details.markers[0].objeto.params.cd_insumo
    };

    LoadingService.showLoading();

    // Pontos
    $scope.report.pontos = $scope.details.markers;

    // Data
    $scope.getPeriodo = function(details) {
      if (!details) {
        return;
      }
      const datas = details.pontos.map(function(ponto) {
        return new Date(ponto.created_at);
      });

      return {
        inicio: _.min(datas),
        fim: _.max(datas)
      };
    };
    const datas = $scope.report.pontos.map(function(ponto) {
      return new Date(ponto.objeto.created_at);
    });
    $scope.report.periodo = {
      inicio: _.min(datas),
      fim: _.max(datas)
    };

    // Número máximo de linhas
    $scope.report.maxSamples = _.max($scope.report.pontos.map(function(marker) {
      return marker.objeto.samples.length;
    }));

    // Responsáveis
    $scope.report.responsaveis = _.uniq(_.map($scope.report.pontos, 'objeto.user.user_name')).join(',');

    try {
      // Calcula a média da área dos pontos
      $scope.report.areaPorAmostragem = _.sumBy($scope.report.pontos, 'objeto.area') / $scope.report.pontos.length;
    } catch (error) {
      console.error('Falha ao recuperar área da amostra', error);
    }

    const promises = [];

    // Informações do plantio
    promises.push(InformacoesCultivaresService.getDataPlantio(params).then(function(result) {
      $scope.report.plantio = result.data.data_plantio;
    }));

    // Informações da Cultivar
    promises.push(InformacoesCultivaresService.get(params).then(function(result) {
      $scope.report.informacaoCultivar = (result.data || [])[0];
    }));

    $q.all(promises).then(function() {
      $scope.report.ready = true;
      LoadingService.hideLoading();
      $timeout(function() {
        angular.element('#hidden-print-produtividade').click();
      });
    })
      .catch(function(error) {
        MessagesService.alert('Ocorreu um erro ao gerar o relatório.');
        console.error('Falha ao gerar relatório', error);
      })
      .finally(LoadingService.hideLoading);
  };
});
